export default __webpack_public_path__ + "film-strip-with-two-photograms.png";